import { RouteStep } from '~/routes/calculations/types';
import { OwnProps } from '~/types/ownProps';
import { Props } from '../';

function meetsDataDependencies(props: OwnProps) {
  const {
    application: { hasAuto, hasHome },
    currentProperty: { newPurchase },
  } = props;

  const isReshopper = hasHome && !newPurchase;

  return hasAuto || isReshopper;
}

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/current-policies',
  isAccessible: ({ application, currentProperty }: Props) => {
    if (application.isAutoOnly) {
      return true;
    }

    if (application.bundled) {
      return true;
    }

    return !currentProperty.newPurchase;
  },
  breadcrumbStep: 'property',
  meetsDataDependencies,
};

export default step;
